import * as React from "react";
const CustomerSupportIconSvg = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.168 15.3583H10.8346L7.12629 17.8249C6.57629 18.1916 5.83464 17.8 5.83464 17.1333V15.3583C3.33464 15.3583 1.66797 13.6916 1.66797 11.1916V6.19157C1.66797 3.69157 3.33464 2.0249 5.83464 2.0249H14.168C16.668 2.0249 18.3346 3.69157 18.3346 6.19157V11.1916C18.3346 13.6916 16.668 15.3583 14.168 15.3583Z"
      stroke="#404548"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0005 9.46667V9.29171C10.0005 8.72504 10.3505 8.42503 10.7005 8.18336C11.0422 7.95003 11.3838 7.65004 11.3838 7.10004C11.3838 6.33337 10.7672 5.71667 10.0005 5.71667C9.23383 5.71667 8.61719 6.33337 8.61719 7.10004"
      stroke="#404548"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99495 11.4583H10.0024"
      stroke="#404548"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default CustomerSupportIconSvg;
